function CustomMarker(map, icon, content, coord, isNeedHover = false) {
  this.map_ = map;
  this.isHover = isNeedHover;
  this.icon_ = icon;
  this.content_ = content;
  this.coord_ = coord;
  this.div_ = null;
  this.draw = () => {
      const overlayProjection = this.getProjection();
      let position = overlayProjection.fromLatLngToDivPixel(this.coord_);
      this.div_.style.left = position.x - 30 + 'px';
      this.div_.style.top = position.y - 60 + 'px';
  };
  this.onAdd = () => {
      const div = document.createElement('div');
      div.classList.add('marker');
      if (this.isHover) {
          div.classList.add('marker-hover');
      }
      div.innerHTML = `<div class="marker_ico" style="background-image: url(${this.icon_})"></div><div class="marker_textWrp"><div class="marker_text"><span>${this.content_}</span></div></div>`;
      const marker = this;
      google.maps.event.addDomListener(div, 'click', function() {
          google.maps.event.trigger(marker, 'click');
      });
      this.div_ = div;
      const panes = this.getPanes();
      panes.overlayMouseTarget.appendChild(this.div_);
  };
  this.setMap(map);
  this.getPosition = function() {
      return coord;
  };
  this.remove = function(/*event*/) {
      this.div_.remove();
  };
}

CustomMarker.prototype = new google.maps.OverlayView() || $.noop;

let $transportMap = $("#transportMap");

let mapParams = {
  el: $transportMap.get(0),
  center: APP_CONFIGS.buildingLatLng,
  disableDefaultUI: true,
  zoomControl: true,
  zoom: 14,
  styles: APP_CONFIGS.gmapsStyles,
streetViewControl: true,
streetViewControlOptions: {
  position: google.maps.ControlPosition.LEFT_BOTTOM
},
};

let windowBreakpoint = getWindowSizeBreakpoint();

if (windowBreakpoint === "md") {
  mapParams.center = {
      lat: APP_CONFIGS.buildingLatLng.lat,
      lng: APP_CONFIGS.buildingLatLng.lng + 0.0075
  };
} else if (windowBreakpoint === "sm") {
  mapParams.zoom = 14;
  mapParams.center = {
      lat: APP_CONFIGS.buildingLatLng.lat + 0.003,
      lng: APP_CONFIGS.buildingLatLng.lng + 0.009
  };
} else if (windowBreakpoint === "xs") {
  mapParams.center = {
      lat: APP_CONFIGS.buildingLatLng.lat + 0.0033,
      lng: APP_CONFIGS.buildingLatLng.lng + 0.006
  };
  mapParams.zoom = 14;
}

if ( window.is_transport )
  mapParams.zoom = init_zoom;

const transportMap = new GMaps(mapParams);

{
  var path = [
      [55.957113, 37.447534],
      [55.959647, 37.452028],
      [55.958398, 37.454493],
      [55.95665, 37.451858],
      [55.956303, 37.448081],
      [55.957113, 37.447534]
      // [55.956900, 37.447320],
  ];

  transportMap.drawPolygon({
      paths: path,
      strokeColor: "#251914",
      strokeOpacity: 1,
      strokeWeight: 2,
      fillColor: "#251914",
      fillOpacity: 0
  });
}

// new CustomMarker(transportMap.map, 'офис', 'офис', new google.maps.LatLng(window.officeCoords.lat, window.officeCoords.lng), false);
new CustomMarker(transportMap.map, "/img/markers/r.svg", "Офис продаж", new google.maps.LatLng(window.officeCoords.lat, window.officeCoords.lng));

if (window.infrasObjsMarkers) {
  window.infrasObjsMarkers = _.sortBy(window.infrasObjsMarkers, function(o) {
      return o.coord[0];
  });
  window.infrasObjsMarkers.forEach(item => {
      new CustomMarker(transportMap.map, item.img, item.title, new google.maps.LatLng(...item.coord), item.hover);
  });
}





